import { EReportConversionTypes } from 'entities/Report';
import { i18n } from 'i18n';

export const REPORT_CONVERSION_TYPES = () => ({
	[EReportConversionTypes.CROSS]: i18n.t('Кросс'),
	[EReportConversionTypes.DIRECT]: i18n.t('Прямые'),
});

export const REPORT_CONVERSION_TYPES_OPTIONS = () =>
	Object.keys(REPORT_CONVERSION_TYPES()).map((key) => ({
		label: REPORT_CONVERSION_TYPES()[key as keyof ReturnType<typeof REPORT_CONVERSION_TYPES>],
		value: key,
	}));
